import makeStyles from '@mui/styles/makeStyles';

export default makeStyles(theme => ({
  container: {
    width: '100vw',
    height: '100vh',
    overflow: 'auto'
  },
  gridWrapper: {
    height: '100%'
  },
  formWrapper: {
    backgroundColor: theme.palette.common.white,
    padding: theme.spacing(10, 3),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    height: 'auto'
  },
  signupForm: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    maxWidth: '485px',
    color: theme.palette.common.text,
    textAlign: 'center',
    '& a': {
      textDecoration: 'none'
    }
  },
  formControl: {
    '&>div': {
      width: '100%'
    }
  },
  iconWrapper: {
    display: 'inline-block',
    backgroundColor: theme.palette.primary.darkBlue,
    padding: '12px',
    borderRadius: '50px',
    width: '65px',
    height: '65px',
    margin: '0 auto',
    marginBottom: '15px',
    '& svg': {
      display: 'block',
      fontSize: '2.5rem',
      width: '40px',
      height: '40px',
      lineHeight: '1',
      marginRight: '0px'
    }
  },
  title: {
    color: theme.palette.common.offBlack,
    fontSize: theme.typography.h1.fontSize,
    fontWeight: theme.typography.h1.fontWeight,
    letterSpacing: '-.5px',
    marginBottom: '10px'
  },
  subtitle: {
    fontSize: '1rem',
    fontWeight: '500',
    marginBottom: '30px'
  },
  signupSeparator: {
    textTransform: 'uppercase',
    paddingLeft: '10px',
    paddingRight: '10px',
    whiteSpace: 'nowrap'
  },
  signupSeparatorContainer: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: '10px',
  },
  signupSeparatorBorder: {
    borderBottom: '1px solid',
    borderColor: theme.palette.common.offBlack,
    width: '100%'
  },
  disclaimer: {
    color: theme.palette.common.text,
    '& a': {
      color: theme.palette.primary.main
    }
  },
  cancelButton: {
    fontSize: '1.1rem',
    textTransform: 'capitalize',
    padding: '12px',
    boxShadow: 'none',
    margin: '0 auto',
    marginTop: '20px',
    marginBottom: '10px',
    width: '100%',
    maxWidth: '200px',
    backgroundColor: theme.palette.common.lightGrey,
    color: theme.palette.common.offBlack
  },
  errorMessage: {
    color: 'red',
    marginTop: theme.spacing(1),
    textAlign: 'left'
  },
  signupImageWrapper: {
    position: 'relative',
    backgroundColor: theme.palette.primary.main,
    height: '100%'
  },
  imageOfTheWeek: {
    position: 'relative',
    minHeight: '200px',
    height: '100%',
    width: '100%',
    backgroundSize: 'cover',
    backgroundPosition: 'center right',
    '&:after': {
      content: '\'\'',
      position: 'absolute',
      bottom: '0px',
      left: '0px',
      right: '0px',
      height: '120px',
      background: 'linear-gradient(to top, rgba(0, 0, 0, .75) 0%, transparent 100%)'
    }
  },
  imageOfTheWeekText: {
    position: 'absolute',
    left: '0px',
    right: '0px',
    bottom: '0px',
    color: theme.palette.common.white,
    fontWeight: '500',
    textAlign: 'right',
    padding: theme.spacing(2, 3),
    zIndex: 1
  },
  passwordStrengthMessage: ({ passwordStrengthColor }) => ({
    marginTop: theme.spacing(1),
    textAlign: 'left',
    '& > span': {
      color: passwordStrengthColor
    }
  }),
  action: {
    display: 'flex'
  }
}));
